import React, { Component } from 'react';
import { connect } from 'react-redux';
import { loadStore } from '../../../redux/modules/store';
import BrtIcon from './icone_spedizionieri/Brt';
import DhlIcon from './icone_spedizionieri/Dhl';
import FedexIcon from './icone_spedizionieri/Fedex';
import GlsIcon from './icone_spedizionieri/Gls';
import SdaIcon from './icone_spedizionieri/Sda';

class Spedizionieri extends Component {
  componentDidMount() {
    this.props.loadStore();
  }

  render() {
    let tipoSpedizioni = [
      {
        id: 0,
        name: 'BRT',
        img: <BrtIcon style={{ width: 40, height: 24 }} />,
        on: this.props.hasBrt,
      },

      {
        id: 1,
        name: 'DHL',
        img: <DhlIcon style={{ width: 40, height: 24 }} />,
        on: this.props.hasDhl,
      },

      {
        id: 2,
        name: 'FEDEX',
        img: <FedexIcon style={{ width: 40, height: 24 }} />,
        on: this.props.hasFedEx,
      },

      {
        id: 3,
        name: 'GLS',
        img: <GlsIcon style={{ width: 40, height: 24 }} />,
        on: this.props.hasGls,
      },

      {
        id: 4,
        name: 'SDA',
        img: <SdaIcon style={{ width: 40, height: 24 }} />,
        on: this.props.hasSda,
      },
    ];

    const listaSpedizioni = tipoSpedizioni
      .filter(item => item.on)
      .map(item => item.img);

    return (
      <div className="pad-left" style={{ display: 'flex', gap: 8 }}>
        {listaSpedizioni}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  has: state.store.data.funzionalita,
  hasBrt: state.store.data.funzionalita.allowBrtLogo,
  hasDhl: state.store.data.funzionalita.allowDhlLogo,
  hasFedEx: state.store.data.funzionalita.allowFedexLogo,
  hasGls: state.store.data.funzionalita.allowGlsLogo,
  hasSda: state.store.data.funzionalita.allowSdaLogo,
});

export default connect(mapStateToProps, { loadStore })(Spedizionieri);
